import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { safeJsonParse } from '../../utils/jsonUtils'
import Grid from '@mui/material/Grid'
import { Button, Paper, Checkbox, FormGroup, FormControlLabel, Typography } from '@mui/material';
import Textarea from '@mui/joy/Textarea'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Fab from '@mui/material/Fab'
import TextField from '@mui/material/TextField'
import FormControlJoy from '@mui/joy/FormControl'
import RadioJoy from '@mui/joy/Radio'
import RadioGroupJoy from '@mui/joy/RadioGroup'
import toast from 'react-hot-toast'
import { BeatLoader } from 'react-spinners'
import DOMPurify from 'dompurify'
import axios from '../../api/axios'
import socket from '../../socket'
import { getDateOnly } from '../../utils/dateUtils'
import { VEHICLE_TYPES } from '../../utils/vehicleType'

export default function Upload() {
   const navigate = useNavigate()
   const [account, setAccount] = useState(null);
   const [supportID, setSupportID] = useState('')
   const [userName, setUserName] = useState('')
   const [creditAmount, setCreditAmount] = useState(0)

   const [vehicleType, setVehicleType] = useState('')
   const [vehicleBrand, setVehicleBrand] = useState('')
   const [vehicleSeries, setVehicleSeries] = useState('')
   const [buildYear, setBuildYear] = useState()
   const [buildYearValue, setBuildYearValue] = useState('')
   const [uploadBtnFlag, DisableUploadButton] = useState(true)

   const [HP, setHP] = useState('')
   const [KW, setKW] = useState('')
   const [transmission, setTransmission] = useState('')
   const [VINnumber, setVINnumber] = useState('')
   const [noRegNumber, setNoRegNumber] = useState(false)
   const [regStatus, setRegStatus] = useState('') // '', 'checking', 'found', 'notfound'

   const [message, setMessage] = useState('')
   const [term, setTerm] = useState(false)

   const [userId, setUserID] = useState('')
   const [fileData, setFileData] = useState([])
   const inputElement = useRef('fileInput')

   const [policy, setPolicy] = useState('')
   const [termViewFlag, setTermViewFlag] = useState(false)
   const [isLoading, setIsLoading] = useState(false)
   const [enoughCredits, setEnoughCredits] = useState(false)

   const [userType, setUserType] = useState('')

   const [checked, setChecked] = useState({
      stage1:    false,
      stage2:    false,
      atraktor:  false,
      original:  false,
      egroff:    false,
      dpfoff:    false,
      dtcoff:    false,
      adblueoff: false,
      gpfopfoff: false,
      popbang:   false,
      decat:     false,
      vmaxoff:   false,
      popcorn:   false,
      gearbox:   false,
   });
   const optionLabels = {
      stage1:    'Stage 1',
      stage2:    'Stage 2',
      atraktor:  'A-traktor',
      original:  'Original',
      egroff:    'EGR OFF',
      dpfoff:    'DPF OFF',
      dtcoff:    'DTC OFF',
      adblueoff: 'AdBlue OFF',
      gpfopfoff: 'GPF/OPF OFF',
      popbang:   'Pop & Bang',
      decat:     'DECAT',
      vmaxoff:   'VMAX OFF',
      popcorn:   'Popcorn / Hardcut',
      gearbox:   'Gearbox tuning',
   };
   const MAX_SIZE = 10485760; // 10 MB
   const REG_NOT_FOUND = 'Vehicle not found. Check "No registration number available" and enter the vehicle details.'
   const TuningTypeKeys = ['stage1', 'stage2', 'atraktor', 'original'];
   const ExtrasKeys = Object.keys(checked).filter(k => !TuningTypeKeys.includes(k));
   const getCheckedString = (keys) => keys
      .filter(key => checked[key])
      .map(key => optionLabels[key])
      .join(', ');

   const handleTuningOptions = (event) => {
      setChecked({
         ...checked,
         [event.target.name]: event.target.checked,
      });
   };

   // const checkedCount = Object.values(checked).filter(Boolean).length;

   useEffect(()=>{
      const user = localStorage.getItem('user');
      if(user){
         let parse = safeJsonParse(user);
         setAccount(parse);
      }
   },[]);

   const getContents = async () => {
      try {
         await axios
            .post(`getContents`)
            .then((result) => {
               setPolicy(result.data.privacy)
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const getUserType = async (id) => {
      try {
         await axios
            .post(`getUserType`, {
               id: id,
            })
            .then((result) => {
               if (result.data.type) {
                  setUserType(result.data.type)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const getSumCredit = async (id) => {
      try {
         await axios
            .post(`getSumCredit`, { id })
            .then((result) => {
               if (userType === 'retailer') {
                  setEnoughCredits( true )
               } else if (result.data.status) {
                  setCreditAmount( result.data.data )
                  setEnoughCredits( result.data.data >= 45 )
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const handleFileload = () => {
      inputElement.current.click()
   }

   const getFile = async (e) => {
      const selectedFiles = Array.from(e.target.files);
      const validFiles = [];

      selectedFiles.forEach((fileobj) => {
         const arr = fileobj.name.split('.');
         const element = arr[arr.length - 1];
         const type = element.toLowerCase();

         const forbidden = [
            'exe', 'bat', 'scr', 'vbs', 'cmd',
            'py', 'jar', 'pl', 'csh', 'sh'
         ];

         if (forbidden.includes(type)) {
            toast.error(`Unsupported file type: ${fileobj.name}`);
            return;
         }

         if (fileobj.size > MAX_SIZE) {
            toast.error(`Max file size is 10 MB: ${fileobj.name}`);
            return;
         }

         validFiles.push(fileobj);
      });

      if (validFiles.length > 0) {
         setFileData((prev) => [...prev, ...validFiles]);
      }

      // Rensa input så att samma fil kan väljas igen vid behov
      e.target.value = '';
   };

   // Slår upp regnumret hos Biltema. Svaret innehåller bara hittad/inte hittad,
   // fordonsuppgifterna sparas på ärendet och visas bara för admin.
   const checkRegNumber = async () => {
      if (!VINnumber) return false
      setRegStatus('checking')
      try {
         const result = await axios.post(`checkRegNumber`, { reg: VINnumber })
         setRegStatus(result.data.status ? 'found' : 'notfound')
         return result.data.status
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         setRegStatus('notfound')
         return false
      }
   }

   const handleNoRegNumber = (event) => {
      setNoRegNumber(event.target.checked)
      if (event.target.checked) {
         setVINnumber('')
         setRegStatus('')
      }
   }

   const upload = async () => {
      // const blocked = ['exe','bat','scr','vbs','cmd','py','jar','pl','csh','sh'];
      if (!fileData || fileData.length === 0) {
         toast.error('No file selected');
         return;
      }
      for (let file of fileData) {
         // const parts = file.name.split('.');
         // const ext = parts[parts.length - 1].toLowerCase();
         // if (blocked.includes(ext) && file.name.toLowerCase() !== ext) {
         //    toast.error(`Unsupported file type: ${ext}`);
         //    return;
         // }
         if (file.size > MAX_SIZE) {
            toast.error(`Max file size per file is 10 MB`);
            return;
         }
      }
      if (noRegNumber) {
         if (!vehicleType) {
            toast.error('Select a vehicle type')
            return
         }
         if (!vehicleBrand) {
            toast.error('Select a vehicle brand')
            return
         }
         if (!transmission) {
            toast.error('Select a transmission type')
            return
         }
      } else {
         if (!VINnumber) {
            toast.error('Enter a registration number')
            return
         }
         if (regStatus !== 'found' && !(await checkRegNumber())) {
            toast.error(REG_NOT_FOUND)
            return
         }
      }
      if (!term) {
         toast.error('Please accept the terms')
         return
      }
      let params = new FormData()

      const tuningType = getCheckedString(TuningTypeKeys);
      const extras     = getCheckedString(ExtrasKeys);
      // console.log( tuningType )
      // console.log( extras )
      const data = {
         orderId: '',
         userId,
         email: account?.email,
         client: userName,
         fileName: fileData.map(f => f.name),
         fileSize: fileData.map(f => f.size),
         fileType: fileData.map(f => f.type),
         fileModified: fileData.map(f => f.lastModified),
         // Med regnummer hämtas fordonsuppgifterna från Biltema i backend
         vehicleType:   noRegNumber ? vehicleType : 'Car',
         vehicleBrand:  noRegNumber ? vehicleBrand : '',
         vehicleSeries: noRegNumber ? vehicleSeries : '',
         buildYear:     noRegNumber ? buildYear : undefined,
         HP,
         KW,
         transmission:  noRegNumber ? transmission : '',
         VINnumber:     noRegNumber ? '' : VINnumber,
         noRegNumber,
         tuningType,
         extras,
         message,
         note: '',
         status: 'requested',
         createdAt: getCustomDate(),
         updatedAt: getCustomDate(),
         readStatus: false,
      }
      fileData.forEach((file) => {
         params.append('file', file);
      });
      params.append('data', JSON.stringify(data))
      if (!isLoading) {
         setIsLoading(true)
         try {
            await axios
               .post(`uploadFile`, params)
               .then((result) => {
                  if (result.data.status) {
                     socket.emit('request', { to: supportID, name: userName })
                     toast.success(result.data.data)
                     setUserName('')
                     setVehicleType('')
                     setVehicleBrand('')
                     setVehicleSeries('')
                     setBuildYear(new Date())
                     setHP('')
                     setKW('')
                     setTransmission('')
                     setVINnumber('')
                     setNoRegNumber(false)
                     setRegStatus('')
                     setMessage('')
                     setTerm('')
                     setFileData({})
                     setIsLoading(false)
                     navigate('/dashboard')
                  } else {
                     toast.error(result.data.data)
                  }
               })
         } catch (error) {
            if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
         }
      } else {
         toast.error('Still uploading...')
      }
   }

   const getSupportID = async () => {
      try {
         await axios
            .post(`getSupportID`)
            .then(async (result) => {
               if (result.data.status) await setSupportID(result.data.data)
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const getCustomDate = getDateOnly

   const deleteFile = (index) => {
      setFileData((prev) => {
         const updated = prev.filter((_, i) => i !== index);
         return updated;
      });
   };

   useEffect(() => {
      const now = new Date()
      const MaxYear = now.getFullYear()
      if (!buildYearValue || buildYearValue <= 0) {
         setBuildYearValue('')
      } else if( buildYearValue > MaxYear) {
         setBuildYearValue(MaxYear)
      /*
      } else if( buildYearValue < 1900) {
         setBuildYearValue(1900)
      */
      } else {
         setBuildYear(new Date(buildYearValue, 0))
      }
   }, [buildYearValue])

   /*
   useEffect(() => {
      console.log("Build date is " + buildYear)
   }, [buildYear])
   */

   useEffect(() => {
      DisableUploadButton(!term || !enoughCredits)
   }, [term, enoughCredits])

   useEffect(() => {
      if (!HP || HP === 0) {
         setHP('')
         setKW('')
      } else {
         setKW( (HP * 0.7457).toFixed(1) )
      }
   }, [HP, KW])

   useEffect(() => {
      getSupportID()
      if (account) {
         setUserName(account?.name)
         setUserID(account?._id)
         getUserType(account?._id)
         getSumCredit(account?._id)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [account])

   useEffect(() => {
      getContents()
   }, [])


   return (
      <Box
         sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: 'rgb(229, 229, 229)',
            overflowY: 'overlay',
         }}
      >
         {termViewFlag ? (
            <Box
               sx={{
                  flexGrow: 1,
                  p: 3,
                  bgcolor: 'rgb(229, 229, 229)',
                  overflowY: 'overlay',
               }}
            >
               <Box
                  sx={{
                     mt: '80px',
                     display: 'flex',
                     justifyContent: 'space-between',
                  }}
               >
                  <h2 style={{ color: '#FA870B', margin: '0px' }}>
                     Privacy Policy
                  </h2>
                  <Box>
                     <Fab
                        color="primary"
                        aria-label="add"
                        onClick={() => setTermViewFlag(false)}
                     >
                        <ArrowBackIcon />
                     </Fab>
                  </Box>
               </Box>
               <Box
                  sx={{
                     mt: '10px',
                     borderTop: '5px solid #FA870B',
                     bgcolor: 'white',
                     borderBottomRightRadius: '5px',
                     borderBottomLeftRadius: '5px',
                     overflow: 'auto',
                     p: '10px',
                     height: '60vh',
                  }}
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(policy) }}
               />
            </Box>
         ) : (
            <>
               <Box sx={{ mt: '80px' }}>
                  <h3 style={{ color: '#FA870B', margin: '0px' }}>
                     Upload File
                  </h3>
               </Box>
               <Box
                  sx={{
                     mt: '10px',
                     borderTop: '5px solid #FA870B',
                     bgcolor: 'white',
                     borderBottomRightRadius: '5px',
                     borderBottomLeftRadius: '5px',
                     p: '10px',
                  }}
               >
                  <Grid
                     container
                     spacing={{ xs: 2, md: 3 }}
                     columns={{ xs: 4, sm: 6, md: 12 }}
                  >
                     <Grid item xs={12} sm={6} md={7}>
                        <Box
                           sx={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              border: '1px dotted',
                              borderRadius: '20px',
                              flexDirection: 'column',
                              p: '30px',
                              gap: '10px',
                              alignItems: 'center',
                           }}
                        >
                           <Box>
                              <CloudUploadIcon
                                 sx={{ color: '#FA870B', fontSize: '70px' }}
                              />
                           </Box>
                           <Box>Drag and drop your file here</Box>
                           <Box>or</Box>
                           <Box>
                              <input
                                 ref={inputElement}
                                 type="file"
                                 multiple
                                 style={{ display: 'none' }}
                                 onChange={getFile}
                              />
                              <Button
                                 variant="outlined"
                                 sx={{
                                    border: '1px solid #FA870B',
                                    borderRadius: '12px',
                                    color: '#FA870B',
                                 }}
                                 onClick={handleFileload}
                              >
                                 Browse File
                              </Button>
                           </Box>
                        </Box>
                     </Grid>
                     <Grid item xs={12} sm={6} md={5}>
                        {fileData.length > 0 && (
                           <Box mt={4}>
                              {fileData.map((file, index) => (
                                 <Box key={index} className="select-file" mt={2}>
                                    <Box className="file-group-box">
                                       <Box className="upload-img-box">
                                          <UploadFileIcon className="upload-img-icon" />
                                       </Box>
                                       <Box className="file-info">
                                          <Box>
                                             <Box className="filename-string">{file.name}</Box>
                                             <Box>{(file.size / 1_000_000).toFixed(4)} MB</Box>
                                          </Box>
                                       </Box>
                                    </Box>
                                    <Box className="close-img-box">
                                       <HighlightOffIcon
                                          className="close-img-icon"
                                          onClick={() => deleteFile(index)}
                                       />
                                    </Box>
                                 </Box>
                              ))}
                           </Box>
                        )}
                     </Grid>
                     <Grid item xs={12} sm={12} md={12}>
                        { (creditAmount >= 100) ||
                          <Box
                            color="#B80F0A"
                            height="40px"
                            width="600px"
                            fontSize="20px"
                          >Your credits are running low. Consider buying more!
                        </Box>}
                     </Grid>
                     <Grid item xs={12} md={6}>
                        <Paper elevation={3} sx={{ padding: 2, backgroundColor: '#f5f5f5', height: '100%' }}>
                           <Typography variant="h6" gutterBottom>
                           Tuning options
                           </Typography>
                           <FormGroup sx={{ '& .MuiFormControlLabel-root': {my: -1, mb: -1, },
                           }}>
                              <FormControlLabel control={<Checkbox checked={checked.stage1}    onChange={handleTuningOptions} name="stage1" />}    label="Stage 1"           />
                              <FormControlLabel control={<Checkbox checked={checked.stage2}    onChange={handleTuningOptions} name="stage2" />}    label="Stage 2"           />
                              <FormControlLabel control={<Checkbox checked={checked.atraktor}  onChange={handleTuningOptions} name="atraktor" />}  label="A-traktor"         />
                              <FormControlLabel control={<Checkbox checked={checked.original}  onChange={handleTuningOptions} name="original" />}  label="Original"          />
                              <FormControlLabel control={<Checkbox checked={checked.egroff}    onChange={handleTuningOptions} name="egroff" />}    label="EGR OFF"           />
                              <FormControlLabel control={<Checkbox checked={checked.dpfoff}    onChange={handleTuningOptions} name="dpfoff" />}    label="DPF OFF"           />
                              <FormControlLabel control={<Checkbox checked={checked.dtcoff}    onChange={handleTuningOptions} name="dtcoff" />}    label="DTC OFF"           />
                              <FormControlLabel control={<Checkbox checked={checked.adblueoff} onChange={handleTuningOptions} name="adblueoff" />} label="AdBlue OFF"        />
                              <FormControlLabel control={<Checkbox checked={checked.gpfopfoff} onChange={handleTuningOptions} name="gpfopfoff" />} label ="GPF/OPF OFF"      />
                              <FormControlLabel control={<Checkbox checked={checked.popbang}   onChange={handleTuningOptions} name="popbang" />}   label="Pop & Bang"        />
                              <FormControlLabel control={<Checkbox checked={checked.decat}     onChange={handleTuningOptions} name="decat" />}     label="DECAT"             />
                              <FormControlLabel control={<Checkbox checked={checked.vmaxoff}   onChange={handleTuningOptions} name="vmaxoff" />}   label="VMAX OFF"          />
                              <FormControlLabel control={<Checkbox checked={checked.popcorn}   onChange={handleTuningOptions} name="popcorn" />}   label="Popcorn / Hardcut" />
                              <FormControlLabel control={<Checkbox checked={checked.gearbox}   onChange={handleTuningOptions} name="gearbox" />}   label="Gearbox tuning"    />
                           </FormGroup>
                        </Paper>
                     </Grid>
                     <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                           <Grid item xs={6} md={12}>
                              Registration Number
                              <FormControl fullWidth>
                                 <TextField
                                    size="small"
                                    value={VINnumber}
                                    disabled={noRegNumber}
                                    error={regStatus === 'notfound'}
                                    helperText={
                                       regStatus === 'checking' ? 'Looking up vehicle...' :
                                       regStatus === 'notfound' ? REG_NOT_FOUND :
                                       ''
                                    }
                                    onChange={(e) => {
                                    const noSpaceStr = e.target.value.replace(/\s/g, '').toUpperCase();
                                    setVINnumber( noSpaceStr );
                                    setRegStatus('');
                                    }}
                                    onBlur={() => {
                                       if (VINnumber && regStatus === '') checkRegNumber()
                                    }}
                                 />
                              </FormControl>
                              <FormControlLabel
                                 control={<Checkbox checked={noRegNumber} onChange={handleNoRegNumber} />}
                                 label="No registration number available"
                              />
                           </Grid>
                           {noRegNumber && (<>
                           <Grid item xs={6} md={12}>
                              Vehicle Type
                              <FormControl fullWidth>
                                 <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={vehicleType}
                                    onChange={(e) => setVehicleType(e.target.value)}
                                 >
                                    {VEHICLE_TYPES.map((type) => (
                                       <MenuItem key={type} value={type}>{type}</MenuItem>
                                    ))}
                                 </Select>
                              </FormControl>
                           </Grid>
                           <Grid item xs={6} md={12}>
                              Vehicle Brand
                              <FormControl fullWidth>
                                 <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={vehicleBrand}
                                    onChange={(e) => setVehicleBrand(e.target.value)}
                                 >
                                    <MenuItem value="Abarth">Abarth</MenuItem>
                                    <MenuItem value="Alfa-Romeo">Alfa-Romeo</MenuItem>
                                    <MenuItem value="Alpine">Alpine</MenuItem>
                                    <MenuItem value="Aprilia">Aprilia</MenuItem>
                                    <MenuItem value="Aston-Martin">Aston-Martin</MenuItem>
                                    <MenuItem value="Atlas">Atlas</MenuItem>
                                    <MenuItem value="Audi">Audi</MenuItem>
                                    <MenuItem value="BMW">BMW</MenuItem>
                                    <MenuItem value="Bentley">Bentley</MenuItem>
                                    <MenuItem value="Bugatti">Bugatti</MenuItem>
                                    <MenuItem value="BRP">Brp</MenuItem>
                                    <MenuItem value="Buick">Buick</MenuItem>
                                    <MenuItem value="Cadillac">Cadillac</MenuItem>
                                    <MenuItem value="Caterpillar">Caterpillar</MenuItem>
                                    <MenuItem value="Chevrolet">Chevrolet</MenuItem>
                                    <MenuItem value="Chrysler">Chrysler</MenuItem>
                                    <MenuItem value="Citroen">Citroen</MenuItem>
                                    <MenuItem value="Dodge">Dodge</MenuItem>
                                    <MenuItem value="Doosan">Doosan</MenuItem>
                                    <MenuItem value="Ducati">Ducati</MenuItem>
                                    <MenuItem value="Ferrari">Ferrari</MenuItem>
                                    <MenuItem value="Fiat">Fiat</MenuItem>
                                    <MenuItem value="Ford">Ford</MenuItem>
                                    <MenuItem value="Geely">Geely</MenuItem>
                                    <MenuItem value="Harley-Davidson">Harley-Davidson</MenuItem>
                                    <MenuItem value="Honda">Honda</MenuItem>
                                    <MenuItem value="Hummer">Hummer</MenuItem>
                                    <MenuItem value="Hyosung">Hyosung</MenuItem>
                                    <MenuItem value="Hyundai">Hyundai</MenuItem>
                                    <MenuItem value="Infiniti">Infiniti</MenuItem>
                                    <MenuItem value="Jaguar">Jaguar</MenuItem>
                                    <MenuItem value="John Deere">John Deere</MenuItem>
                                    <MenuItem value="KTM">KTM</MenuItem>
                                    <MenuItem value="Kawasaki">Kawasaki</MenuItem>
                                    <MenuItem value="Kia">Kia</MenuItem>
                                    <MenuItem value="Lamborghini">Lamborghini</MenuItem>
                                    <MenuItem value="Land Rover">Land Rover</MenuItem>
                                    <MenuItem value="Lexus">Lexus</MenuItem>
                                    <MenuItem value="Lincoln">Lincoln</MenuItem>
                                    <MenuItem value="Linde">Linde</MenuItem>
                                    <MenuItem value="Lotus">Lotus</MenuItem>
                                    <MenuItem value="Maserati">Maserati</MenuItem>
                                    <MenuItem value="Mazda">Mazda</MenuItem>
                                    <MenuItem value="McLaren">McLaren</MenuItem>
                                    <MenuItem value="Mercedes">Mercedes</MenuItem>
                                    <MenuItem value="Mini">Mini</MenuItem>
                                    <MenuItem value="Mitsubishi">Mitsubishi</MenuItem>
                                    <MenuItem value="Mitsuoka">Mitsuoka</MenuItem>
                                    <MenuItem value="Nio">Nio</MenuItem>
                                    <MenuItem value="Nissan">Nissan</MenuItem>
                                    <MenuItem value="Norton">Norton</MenuItem>
                                    <MenuItem value="Pagani">Pagani</MenuItem>
                                    <MenuItem value="Peugeot">Peugeot</MenuItem>
                                    <MenuItem value="Ponsse">Ponsse</MenuItem>
                                    <MenuItem value="Porsche">Porsche</MenuItem>
                                    <MenuItem value="Ram">Ram</MenuItem>
                                    <MenuItem value="Renault">Renault</MenuItem>
                                    <MenuItem value="Rezvani">Rezvani</MenuItem>
                                    <MenuItem value="Rolls-Royce">Rolls-Royce</MenuItem>
                                    <MenuItem value="Saab">Saab</MenuItem>
                                    <MenuItem value="Scania">Scania</MenuItem>
                                    <MenuItem value="Scion">Scion</MenuItem>
                                    <MenuItem value="Seat">Seat</MenuItem>
                                    <MenuItem value="Skoda">Skoda</MenuItem>
                                    <MenuItem value="Smart">Smart</MenuItem>
                                    <MenuItem value="Subaru">Subaru</MenuItem>
                                    <MenuItem value="Suzuki">Suzuki</MenuItem>
                                    <MenuItem value="Tata">Tata</MenuItem>
                                    <MenuItem value="Toyota">Toyota</MenuItem>
                                    <MenuItem value="Tesla">Tesla</MenuItem>
                                    <MenuItem value="Triumph">Triumph</MenuItem>
                                    <MenuItem value="Vauxhall">Vauxhall</MenuItem>
                                    <MenuItem value="Volkswagen">Volkswagen</MenuItem>
                                    <MenuItem value="Volvo">Volvo</MenuItem>
                                    <MenuItem value="Yamaha">Yamaha</MenuItem>
                                 </Select>
                              </FormControl>
                           </Grid>
                           <Grid item xs={6} md={12}>
                              Transmission Type
                              <FormControl fullWidth>
                                 <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={transmission}
                                    onChange={(e) => setTransmission(e.target.value)}
                                 >
                                    <MenuItem value="Manual">Manual</MenuItem>
                                    <MenuItem value="Automatic">Automatic</MenuItem>
                                 </Select>
                              </FormControl>
                           </Grid>
                           <Grid item xs={6} md={12}>
                              Build Year
                              <FormControl fullWidth>
                                 <TextField
                                    size="small"
                                    value={buildYearValue}
                                    type="number"
                                    onChange={(e) => setBuildYearValue(Number(e.target.value))}
                                 />
                              </FormControl>
                           </Grid>
                           </>)}
                        </Grid>
                     </Grid>
                     <Grid item xs={12} sm={12} md={12}>
                        Message to our engineers
                        <Textarea
                           minRows={4}
                           size="sm"
                           placeholder="Do you have multiple options? Write them here, or just leave a message."
                           value={message}
                           onChange={(e) => setMessage(e.target.value)}
                        />
                     </Grid>
                     <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        className="term-check-box"
                     >
                        <FormControlJoy>
                           <RadioGroupJoy
                              defaultValue="false"
                              name="controlled-radio-buttons-group"
                              value={term}
                              onChange={(e) => setTerm(e.target.value)}
                              style={{ display: 'flex' }}
                           >
                              <p>
                                 <RadioJoy value="true" />
                                 &nbsp;I accept the{' '}
                                 <span
                                    style={{
                                       color: '#FA870B',
                                       cursor: 'pointer',
                                    }}
                                    onClick={() => setTermViewFlag(true)}
                                 >
                                    terms and conditions
                                 </span>
                              </p>
                           </RadioGroupJoy>
                        </FormControlJoy>
                     </Grid>
                     <Grid
                        item
                        xs={12}
                        sm={4}
                        md={4}
                        className="upload-btn-box"
                     >
                        <Button
                           variant="contained"
                           className="btn_blue"
                           style={{ padding: '10px 0' }}
                           fullWidth
                           disabled={uploadBtnFlag}
                           onClick={upload}
                        >
                           {isLoading ? (
                              <BeatLoader color="#fff" size={10} />
                           ) : (
                              enoughCredits? 'Upload' : 'Not enough credits'
                           )}
                        </Button>
                     </Grid>
                  </Grid>
               </Box>
            </>
         )}
      </Box>
   )
}
